import { Navigate, useParams } from "react-router-dom";

// Owner decision D-B (2026-10-03): hiring runs through Recruitment, so the legacy onboarding-step workspace is
// retired. Old links and notifications land on the employee's record instead.
export default function HROnboardingWorkspace() {
  const { memberId } = useParams();
  return <Navigate to={`/business/hr/employees/${memberId}`} replace />;
}
